import { render, staticRenderFns } from "./page24.vue?vue&type=template&id=7dcc6580&scoped=true&"
import script from "./page24.vue?vue&type=script&lang=js&"
export * from "./page24.vue?vue&type=script&lang=js&"
import style0 from "./page24.vue?vue&type=style&index=0&id=7dcc6580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc6580",
  null
  
)

export default component.exports